"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 24 24" id=icon-checkbox-checked-24><path fill-rule=evenodd clip-rule=evenodd d="M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4Zm6.71 16.71a1 1 0 0 1-1.41 0l-4-4a1 1 0 0 1 1.41-1.41L10 14.59l7.29-7.29a1 1 0 0 1 1.41 1.41h.01l-8 8Z"></path></symbol>';
}
